import HelpPane from 'components/Common/HelpPane'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import React, { useContext } from 'react'
import TextLink from 'LuxKit/TextLink'
import ContactContext from 'contexts/contactContext'
interface Props {
  open?: boolean;
  onClose?: () => void;
}

function UltraLuxTransferModal(props: Props) {
  const contact = useContext(ContactContext)

  return <Modal
    isOpen={props.open}
    title="Complimentary airport transfers"
    onClose={props.onClose}
    image={{ id: 'm64c1h992eijvw3pe54' }}
    imageParams={{ height: 280, fit: 'center', aspectRatio: '14:7' }}
  >
    <BodyText variant="medium">
      The Ultra Lux experience starts at home. Commence your travel journey in comfort with a{' '}
      complimentary transfer to your departing airport. After completing your booking,{' '}
      a concierge will get in contact with you to schedule your luxurious ride.
      <br />
      <TextLink weight="regular" href="https://luxuryescapes.com/au/terms-and-conditions" target="_blank">Terms & Conditions</TextLink>
    </BodyText>
    <HelpPane heading="Need help? Call our premium concierge service." contactNumber={contact.defaultContact} />
  </Modal>
}

export default UltraLuxTransferModal
